export default __webpack_public_path__ + "static/media/unique_key_description.2df64d03.svg";